import React, { useState } from 'react';
import { Briefcase, Users, Building2 } from 'lucide-react';
import JobSeekerInterface from './components/JobSeekerInterface';
import RecruiterInterface from './components/RecruiterInterface';

function App() {
  const [activeTab, setActiveTab] = useState('jobseeker');

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-secondary-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Building2 className="h-8 w-8 text-primary-600" />
              <h1 className="ml-3 text-2xl font-bold text-secondary-900">DLFI</h1>
            </div>
            <div className="flex space-x-1 bg-secondary-100 p-1 rounded-lg">
              <button
                onClick={() => setActiveTab('jobseeker')}
                className={`flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  activeTab === 'jobseeker'
                    ? 'bg-white text-primary-600 shadow-sm'
                    : 'text-secondary-600 hover:text-secondary-900'
                }`}
              >
                <Briefcase className="h-4 w-4 mr-2" />
                Job Seeker
              </button>
              <button
                onClick={() => setActiveTab('recruiter')}
                className={`flex items-center px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  activeTab === 'recruiter'
                    ? 'bg-white text-primary-600 shadow-sm'
                    : 'text-secondary-600 hover:text-secondary-900'
                }`}
              >
                <Users className="h-4 w-4 mr-2" />
                Recruiter
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {activeTab === 'jobseeker' ? (
          <JobSeekerInterface />
        ) : (
          <RecruiterInterface />
        )}
      </main>
    </div>
  );
}

export default App; 